module.exports = __webpack_public_path__ + "nc_static/media/iotConnction.53884da2.svg";